module.exports = __webpack_public_path__ + "img/img51.79fd2bf7.svg";